import countries from './countries.json';
import Country from 'models/ActionBar/Country';
import { isUndefined } from './utils';

const getUserCountries = (roles : Array<string>) : Array<Country> => {
  if(isUndefined(roles))
    return [];

  const countriesArray = (countries as unknown as Array<Country>);
  const countriesSuffix = getRolesSuffix(roles);

  return countriesArray.filter(country => {
    return countriesSuffix.some(suffix => country.locale.endsWith(suffix));
  });
};

const getRolesSuffix = (roles : Array<string>) : Array<string> => {
  return roles.reduce<Array<string>>((previous, current) => {
    const suffix = current.slice(-3);
    return previous.includes(suffix) ? previous : [...previous, suffix];
  }, []);
};

export default getUserCountries;